import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";

function ModifieShareholder({
  open,
  handleClose,
  shareholder,
  company,
  onSave,
  initialData = {},
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90vw",
    maxWidth: 600,
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  const userState = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    NoCellulaire: "",
    langue: "",
    department: "",
    PourcentageAction: "",
    isActive: false,
    estOperateur: false,
  });

  useEffect(() => {
    if (shareholder) {
      setFormData({
        firstName: shareholder.firstName,
        lastName: shareholder.lastName,
        username: shareholder.username,
        email: shareholder.email,
        NoCellulaire: shareholder.NoCellulaire,
        langue: shareholder.langue,
        department: shareholder.department,
        PourcentageAction: shareholder.PourcentageAction,
        isActive: shareholder.EstInactif,
        storeNumber: company?.noAccpac,
        companyName: company?.nom,
        noCompany: company?.noCompagnie,
        openingDate: company?.dateOuverture,
        estOperateur: shareholder.estOperateur,
      });
    }
  }, [shareholder]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

    const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prev) => ({ ...prev, estOperateur: checked }));
  };
  const handleSubmit = async () => {
    const shareholderDTO = {
      FirstName: formData.firstName,
      LastName: formData.lastName,
      Username: formData.username,
      Email: formData.email,
      NoCellulaire: formData.NoCellulaire,
      Langue: formData.langue,
      Department: formData.department,
      PourcentageAction: formData.PourcentageAction,
      EstInactif: !formData.isActive,
      noCompany: company.noCompagnie,
      estOperateur: formData.estOperateur,
    };

    

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/employee/SaveShareholder`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState.token}`,
          },
          body: JSON.stringify(shareholderDTO),
        },
      );

      const result = await response.json();
      if (result !== "echec") {
        onSave();
        handleClose();
      } else {
        alert("Erreur lors de la sauvegarde");
      }
    } catch (error) {
      alert("Erreur lors de la sauvegarde");
    }
  };


  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <h2 style={{ marginBottom: 16 }}>
          {initialData?.id ? "Edit Shareholder" : "Add New Shareholder"}{" "}
          {company?.nom && `for ${company.nom}`}
        </h2>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
          <TextField
            label="Store Number"
            name="storeNumber"
            value={formData.storeNumber}
            disabled
            fullWidth
          />
          <TextField
            label="Company Name"
            name="companyName"
            value={formData.companyName}
            disabled
            fullWidth
          />
          <TextField
            label="Opening Date"
            name="openingDate"
            type="date"
            disabled
            value={
              formData.openingDate ? formData.openingDate.split("T")[0] : ""
            }
            InputLabelProps={{ shrink: true }}
          />
          {/* Move the isActive checkbox here */}
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.estOperateur}
                onChange={handleCheckboxChange}
              />
            }
            label="Exploitant"
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="Prenom"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Nom"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="No Cellulaire"
            name="NoCellulaire"
            value={formData.NoCellulaire}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Langue"
            name="langue"
            value={formData.langue}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Departement"
            name="department"
            value={formData.department}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="% Action"
            name="PourcentageAction"
            type="number"
            value={formData.PourcentageAction}
            onChange={handleChange}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Sauvegarder
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModifieShareholder;
